import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown, faArrowUp, faMinus, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { dateFormat, openLink } from "../../classes/utils"
import "../../styles/scansTable.css"
export default function ({projectScans, setSelectedScan, projectUUID}) {
    const reversedProjectScans = [...projectScans].reverse()
    const externalLinkClickHandler = (e, reportUUID) => {
        e.stopPropagation()
        openLink(`/projects?pid=${projectUUID}&reportUuid=${reportUUID}`)
    }
    return <div className="scans-table min-h-[435px] max-h-[435px] overflow-auto">
        <table>
            <thead className="">
                <tr className="">
                    <th className="sticky-header">Delta</th>
                    <th className="sticky-header th-vuln-score">Score</th>
                    <th className="sticky-header">
                        <h1 className='vulns-long-name'>Vulnerabilities</h1>
                        <h1 className='vulns-short-name hidden'>Vulns</h1>
                    </th>
                    <th className="sticky-header">
                        <h1 className='mitigations-long-name'>Mitigations</h1>
                        <h1 className='mitigations-short-name hidden'>Fixes</h1>
                    </th>
                    <th className="sticky-header" width="35%">Scan date</th>
                </tr>
            </thead>
            <tbody className="">
                {reversedProjectScans.map((scan, i) => {
                    const isPlusDelta = scan.vulnerabilityDelta > 0
                    const isZeroDelta = scan.vulnerabilityDelta === 0
                    
                    return <tr key={`${i}-${scan.timestamp}`} className="cursor-pointer" onClick={() => setSelectedScan(scan)}>
                        <td >
                            <div className="flex justify-center items-center ">
                                {isZeroDelta ? <FontAwesomeIcon className="text-lg" icon={faMinus} />  : isPlusDelta ? <FontAwesomeIcon className="text-xl text-red-400" icon={faArrowUp} /> : <FontAwesomeIcon className="text-xl text-green-300" icon={faArrowDown} />}
                                <span className="ml-2">{scan.vulnerabilityDelta !== 0 ? Math.abs(scan.vulnerabilityDelta): ""}</span>
                            </div>
                        </td>
                        <td className='td-vuln-score'>{scan.securityScore}</td>
                        <td>{scan.vulnerabilityCount}</td>
                        <td>{scan.mitigationCount}</td>
                        <td>
                            <div className='flex items-center justify-center'>
                                <span className="mr-2">{dateFormat(scan.timestamp)}</span>
                                <FontAwesomeIcon className="text-blue-500" icon={faArrowUpRightFromSquare} onClick={(e) => externalLinkClickHandler(e, scan.reportUUID)}/>
                            </div>
                        </td>
                    </tr>
                })}
            </tbody>
        </table>
    </div>
}